export { default as simple } from './simple.js';



// WEBPACK FOOTER //
// ./src/lib/stateMappings/index.js